export class LogsHistogramDataPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "levels",
            "baseName": "levels",
            "type": "{ [key: string]: number; }",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return LogsHistogramDataPoint.attributeTypeMap;
    }
    constructor() {
    }
}
